<template>
  <div class="inspection">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw"  @click="toOxygenSensor">
          <div>氧气传感器</div>
        </div>
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="toCarbonDioxideSensor">
          <div>二氧化碳传感器</div>
        </div>
        <div class="parallelogram-btn-left" @click="toTemperatureAndHumiditySensor">
          <div>温湿度传感器</div>
        </div>
      </div>
      <div class="nav-center">数据报表</div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw" @click="toTemperatureSensor">
          <div>包芯温度传感器</div>
        </div>
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw" @click="toMoistureSensor" >
          <div>包芯水分传感器</div>
        </div>
        <div class="parallelogram-btn-right  parallelogram-btn-active">
          <div>在垛传感器数量</div>
        </div>
      </div>
    </div>
    <div class="report-select">
      <div class="report-select-top" style="justify-content: space-between; margin-bottom: 0">
        <div class="six-font-wrapper"><div class="icon-font">&#xe601;</div>导出数据报表
          <button readonly="readonly" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0" @click="downloadDatarReport"/>
        </div>
        <div style="width: 24vw;display: flex;">
          <div class="input-date-wrapper">
            <el-date-picker
              v-model="time"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="query button" @click="handleSearch">查询</div>
        </div>
      </div>
    </div>
    <div class="task-content">
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading" style="margin-top: 15vh">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <div class="detail-item" style="width: 10%">
              <div class="select-icon" :class="{'select-icon-active': all}" @click="selectAll"></div>
            </div>
            <div class="detail-item" style="width: 25%">采集位置</div>
            <div class="detail-item" style="width: 10%">氧气传感器</div>
            <div class="detail-item" style="width: 10%">二氧化碳传感器</div>
            <div class="detail-item" style="width: 10%">温湿度传感器</div>
            <div class="detail-item" style="width: 10%">包芯温度传感器</div>
            <div class="detail-item" style="width: 10%">包芯水分传感器</div>
            <div class="detail-item" style="width: 15%">入垛时间</div>
          </div>
          <div class="detail-content" v-if="!loading">
            <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
              <div class="detail-item" style="width: 10%">
                <div class="select-icon" :class="{'select-icon-active': data.sign === 1}" @click="selectSingle(data)"></div>
              </div>
              <div class="detail-item" style="width: 25%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.gatherSite">
                  <div class="popover" style="width: 20vw;text-align: center;max-width:20vw" slot="reference">{{data.gatherSite}}</div>
                </el-popover>
              </div>
              <div class="detail-item" style="width: 10%">{{data.o2}}</div>
              <div class="detail-item" style="width: 10%">{{data.co2}}</div>
              <div class="detail-item" style="width: 10%">{{data.env}}</div>
              <div class="detail-item" style="width: 10%">{{data.temp}}</div>
              <div class="detail-item" style="width: 10%">{{data.wet}}</div>
              <div class="detail-item" style="width: 15%">{{getTime(data.time)}}</div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > 9">
            <div class="page-wrapper-left">
              <div>共{{total}}条数据，当前第{{page}}页</div>
              <div style="margin-left: 5px"><DropDown :content="rowsShow" :items="rowsData" v-on:sendInfo = "rowsInfo" class="DropDown" ></DropDown></div>
            </div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle'
import {searchNodeTypeCount, warehouseNode} from '../../../api/basic'
import {getDate, renderTime} from '../../../tools/methods'

export default {
  name: 'TypeStatistics',
  components: { DropDown },
  data () {
    return {
      time: [getDate(false), getDate(true)],
      nodeType: '06',
      nodeName: '在垛传感器数量',
      tableData: [],
      loading: false,
      all: false,
      page: '1',
      rows: '10',
      total: '',
      rowsShow: '10 条/页',
      rowsData: [
        { name: '10 条/页', value: 9 },
        { name: '20 条/页', value: 20 },
        { name: '100 条/页', value: 100 },
        { name: '200 条/页', value: 200 }
      ],
      idList: [],
      excelData: {},
       CountType: [
        { name: "全部", value: "" },
        { name: "按月", value: "2" },
        { name: "按周", value: "1" },
        { name: "按天", value: "0" },
      ],
      SelectConut: "",
      // 起点
      startTimeData:"",
      // 终点
      endTimeData:"",
    }
  },
  created () {
    let body = {
      warehouseNodeId: '',
      warehouseNodeType: '01'
    }
    warehouseNode(body).then(res => {
      console.log(res)
      this.warehouse = res.data
    }).catch(err => {
      console.log(err)
    })
    this.handleSearch()
  },
  methods: {
    // 格式化时间
    getTime: function (time) {
      return renderTime(time)
    },
    toOxygenSensor: function () {
      this.$router.push({
        path: '/historyData',
        query: {
          index: '12'
        }
      })
    },
    toTemperatureAndHumiditySensor: function () {
      this.$router.push({
        path: '/historyData/TemperatureAndHumiditySensor',
        query: {
          index: '12'
        }
      })
    },
    toTemperatureSensor: function () {
      this.$router.push({
        path: '/historyData/TemperatureSensor',
        query: {
          index: '12'
        }
      })
    },
    toCarbonDioxideSensor: function () {
      this.$router.push({
        path: '/historyData/CarbonDioxideSensor',
        query: {
          index: '12'
        }
      })
    },
    toMoistureSensor: function () {
      this.$router.push({
        path: '/historyData/MoistureSensor',
        query: {
          index: '12'
        }
      })
    },
    handleSearch: function () {
      this.loading = true
      this.tableData = []
      this.all = false
      this.idList = []
      let body = {
        startDate: this.time ? this.time[0] : '',
        endDate: this.time ? this.time[1] : '',
        page: this.page,
        rows: this.rows
      }
      searchNodeTypeCount(body).then(res => {
        console.log(res)
        res.data.rows && res.data.rows.map(item => {
          item.sign = 0
        })
        this.tableData = res.data.rows
        this.total = res.data.total
        console.log(this.tableData)
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    },
    rowsInfo: function (data) {
      console.log(data)
      this.rows = data.value
      this.rowsShow = data.name
      this.handleSearch()
    },
    selectAll: function () {
      this.all = !this.all
      let idList = []
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1
          idList.push(data)
        })
        this.idList = idList
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0
          this.idList = []
        })
      }
      console.log(this.idList)
    },
    selectSingle: function (body) {
      this.tableData.map((data, index) => {
        if (body === data) {
          data.sign = data.sign === 1 ? 0 : 1
          if (data.sign === 1) {
            this.idList.push(data)
          } else {
            let idList = []
            this.idList.map((item, index) => {
              if (item !== body) {
                idList.push(item)
              }
            })
            this.idList = idList
          }
          console.log(this.idList)
        }
      })
      this.all = this.idList.length === this.tableData.length
      console.log(this.idList)
    },
    // 导出表格数据处理
    downloadDatarReport () {
      if (!this.idList[0]) {
        this.$message({
          message: '请选择要导出的数据',
          type: 'warning'
        })
      } else {
        console.log(this.tableData)
        const tHeader = ['采集位置', '氧气传感器个数', '二氧化碳传感器个数', '温湿度传感器个数', '包芯温度传感器个数', '包芯水分传感器个数', '入垛时间']
        const filterVal = ['gatherSite', 'o2', 'co2', 'env', 'temp', 'wet', 'time']
        const list = this.idList.map(item => {
          return {
            gatherSite: item.gatherSite,
            o2: item.o2,
            co2: item.co2,
            env: item.env,
            temp: item.temp,
            wet: item.wet,
            time: this.getTime(item.time)
          }
        })
        this.excelData = {
          tHeader: tHeader,
          filterVal: filterVal,
          list: list,
          name: this.nodeName
        }
        console.log(this.excelData)
        this.export2Excel(this.excelData)
      }
    },
    export2Excel: function (body) {
      require.ensure([], () => {
        const {exportJson} = require('../../../vendor/Export2Excel')
        const tHeader = body.tHeader
        const filterVal = body.filterVal
        const list = body.list
        const data = this.formatJson(filterVal, list)
        exportJson(tHeader, data, body.name + '--数据报表')
      })
      this.$message({
        message: '导出数据成功',
        type: 'success'
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style scoped>
  @import "historyData.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/historyData/TypeStatistics.vue